module.exports = __webpack_public_path__ + "images/download@1x.png?09ce5e15";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download@1x.png
// module id = 612
// module chunks = 7